<template>
<div>
  <div class="search-box">
    <div class="search-item">
      <label>账号名：</label>
      <a-input placeholder="请输入" v-model.trim="searchTerm.alias" />
    </div>
    <div class="search-item">
      <label>手机号：</label>
      <a-input placeholder="请输入"  v-model.trim="searchTerm.account"  />
    </div>
    <div class="search-btn" style="display: inline-block;">
      <a-button type="primary" @click="search">查询</a-button>
      <a-button  @click="reset">重置</a-button>
    </div>
  </div>
  <div class="table-header">
    <span>账号列表</span>
    <a-button type="primary" class="addbtn" @click="openModal(1)">
        +&nbsp添加账号
      </a-button>
  </div>
  
  <a-table 
  :locale="{
    emptyText: '暂无数据'
  }"
  :columns="columns" 
  @change="handleTableChange" 
  :pagination="pagination"  
  rowKey="id"  
  :data-source="data"  
  style="margin-top: 12px;" >
    <span slot="role">子账号</span>
    <a slot="action" slot-scope="text" >
      <span @click="openModal(3,text)" class="row-edit">编辑</span>
      <span @click="openModal(2,text)" class="row-edit">修改密码</span> 
      <span v-if="account != text.account" @click="openModal(4,text)">删除</span> 
    </a>
  </a-table>
  <add-modal ref="addAccount" mode='1' @getdata="getdata"></add-modal>
  <edit-modal ref="editAccount" mode='1' @getdata="getdata"></edit-modal>
  <updata-modal ref="updataAccount" mode='1' @getdata="getdata"></updata-modal>
  <del-modal ref="delAccount" mode='1' :pageNum= this.pagination.current :rowSize=this.data.length @getdata="getdata"></del-modal>

</div>
  
</template>
<script>
import page from "@/assets/mixin/page.js";
import addModal from "./addModal"
import editModal from "./editModal"
import updataModal from "./updataModal"
import delModal from "./delModal"
const columns = [
  {
    title: '账号名',
    dataIndex: 'alias',
    key: 'alias',
    width:"25%"
  },
  {
    title: '手机号',
    dataIndex: 'account',
    key: 'account',
    width:"25%"
  },
  {
    title: '角色',
    key: 'role',
    width:"25%",
    scopedSlots: { customRender: 'role' },
  },
  {
    title: '操作',
    key: 'action',
    width:"25%",
    scopedSlots: { customRender: 'action' },
  },
];

export default {
  mixins: [page],
  components:{addModal,editModal,updataModal,delModal},
  data() {
    return {
      data:[],
      columns,
      account:'',
      pagination:{}
    };
  },
  created(){
    this.account = localStorage.getItem("account")||'';
    this.getdata()
  },
  methods:{
    reset(){
      this.searchTerm = {};
      this.getdata();
    },
    search(){
      this.pagination.current = 1;
      // ;
      this.getdata();
    },
    getdata(index){
      // console.log(index||this.pagination.current);
      
      let params = {...this.searchTerm}
      params.pageNum = index||this.pagination.current
      this.pagination.current = params.pageNum;
      this.$http.post('manager/queryRecordList',params).then(res=>{
        this.data = res.rows
        this.pagination.total = res.count;

      })
    },
    openModal(index,text){
      if (index=='1') {
        this.$refs.addAccount.showModal()
      } else if(index=='2') {
        this.$refs.editAccount.showModal(text)
      }else if(index=='3') {
        this.$refs.updataAccount.showModal(text)
      } else if(index == '4') {
        this.$refs.delAccount.showModal(text)
      }
    },
  }
};
</script>
<style lang="less" scoped>

.table-header{
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  span{
    font-size:16px;
    font-weight:400;
    color:rgba(0,0,0,0.85);
  }
}
.row-edit{
  display: inline-block;
  margin-right: 24px;
}
</style>
